import { BankTransferRecipient, BeneficiarySection } from '../../types';
import { BankTransferRecipientsQuery } from './bankTransferRecipients.gql';

const sortByLabelOrName = (
  a: BankTransferRecipient,
  b: BankTransferRecipient,
) => {
  const aLocaleToCompare = a.label || a.name;
  const bLocaleToCompare = b.label || b.name;
  return aLocaleToCompare.localeCompare(bLocaleToCompare);
};

/**
 * Maps the query result to a list of beneficiary sections.
 *
 * @param queryResult - The result of the bank transfer recipients query.
 * @returns An array of beneficiary sections [ 'self' | 'others', BankTransferRecipient[] ]
 */
function mapQueryResultToBeneficiaryList(
  queryResult: BankTransferRecipientsQuery,
): BeneficiarySection[] {
  const selfSectionBeneficiaries: BankTransferRecipient[] = [];
  const othersSectionBeneficiaries: BankTransferRecipient[] = [];

  queryResult.viewer.company.bankTransferRecipients.edges.forEach((edge) => {
    const bankTransferRecipient = edge.node;
    if (bankTransferRecipient.isUserBankAccount) {
      selfSectionBeneficiaries.push(bankTransferRecipient);
    } else {
      othersSectionBeneficiaries.push(bankTransferRecipient);
    }
  });

  const beneficiarySections: BeneficiarySection[] = [];
  if (selfSectionBeneficiaries.length > 0) {
    beneficiarySections.push([
      'self',
      selfSectionBeneficiaries.sort(sortByLabelOrName),
    ]);
  }
  if (othersSectionBeneficiaries.length > 0) {
    beneficiarySections.push([
      'others',
      othersSectionBeneficiaries.sort(sortByLabelOrName),
    ]);
  }

  return beneficiarySections;
}

export default mapQueryResultToBeneficiaryList;
